// Import Toast namespace from the main package
import { Toast as DSToast } from "@packages/ds";

// Import types
import type {
  ToastIconProps,
  ToastCloseProps,
  ToastContentProps,
  ToastTitleProps,
  ToastDescriptionProps,
  ToastLinkProps,
  ToastVariant as ToastVariantType
} from "@packages/ds";

// Create values from the enum type
export const ToastVariant = {
  information: "information" as const,
  warning: "warning" as const,
  success: "success" as const,
  error: "error" as const
} satisfies Record<keyof typeof ToastVariantType, string>;

// Extract the properties for re-export
const Provider = DSToast.Provider;
const Root = DSToast.Root;
const Viewport = DSToast.Viewport;
const Content = DSToast.Content;
const Title = DSToast.Title;
const Description = DSToast.Description;
const Link = DSToast.Link;
const Close = DSToast.Close;
const Icon = DSToast.Icon;

// Re-export the Toast namespace as-is
const Toast = DSToast;

// Re-export components via named exports
export {
  Toast,
  Provider,
  Root,
  Viewport,
  Content,
  Title,
  Description,
  Link,
  Close,
  Icon
};

// Re-export types
export type {
  ToastIconProps,
  ToastCloseProps,
  ToastContentProps,
  ToastTitleProps,
  ToastDescriptionProps,
  ToastLinkProps
};

// Default export
export default Toast;
